// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2J2_3","visuallyhidden":"Y9XPS","hide-text":"_1wXKX","center":"_2Kswl","noprint":"_1FdNS","button":"_8u-7G","streamer":"_1l35q","title":"t4NrE","header":"_39bNa","headerClickable":"_2-8gS","root":"_1IV3d","body":"drO9i","rootButtonToggleable":"_2joFT","rootIsCollapsed":"_76puq","rootHeaderToggleable":"XbvHK"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-factbox/styles/Factbox.scss
 ** module id = 941
 ** module chunks = 1
 **/